import {
  useEffect,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import {
  ArrowIcon,
  ResizeIcon,
  ShrinkIcon
} from 'assets/icons'
import {
  PENDING,
  REJECTED
} from 'utils/constants'
import { isNotMobile } from 'utils/helpers'
import { AskToSignUpModal } from 'components/Content/AskToSignUpModal'
import { BlogList } from 'components/Notifications/CommunityBlogs/BlogList'
import { Comments } from 'components/Notifications/CommunityBlogs/Comments'
import { COLORS } from 'utils/styles'
import {
  getNotificationMessage,
  setCloseChatModal,
  setComments,
  getComments,
  setBlogParent,
  setHideNotification,
  setHideChat,
  setHideDrawerAnimation,
  showCurrentChatFriendMarkerCoordinate
} from 'store'
import { StyledDrawerContent } from '../styled'

export const Content = ({
  activeProfile,
  adminNotifications,
  animateMarkerFilter,
  animateOut,
  askToSignUp,
  blogParent,
  chosenBlogIndex,
  chosenNotifBlog,
  closeDrawer,
  comments,
  commentsOption,
  getCommentsStatus,
  getPostsStatus,
  hideNotification,
  hoveringChevron,
  isLoggedIn,
  newPostsOption,
  postCommentsStatus,
  posts,
  postsOption,
  profileItem,
  putCommentsStatus,
  setAskToSignUp,
  setHoveringChevron,
  setWiden,
  setWidenAnimation,
  subscribeToProfileStatus,
  widen,
  widenAnimation
}) => {
  const dispatch = useDispatch()
  const [widenBtnClicked, setWidenBtnClicked] = useState(false)
  const from = 'normal-content'

  const shouldWiden = () => widen && widenAnimation && isNotMobile()

  const getDrawerHeight = () => {
    let drawerHeight = window.innerHeight - 120

    if (postsOption.type === 'marker') {
      drawerHeight -= '26'
    }

    return drawerHeight + 'px'
  }

  const goToHeaderOriginalPos = () => {
    let targetName = ''
    if (isNotMobile() && blogParent.length) {
      targetName = chosenBlogIndex === 0 ? '#hiddenItem' : '#blogEndItem' + (chosenBlogIndex - 1)
    } else {
      targetName = '#blogStartItem' + chosenBlogIndex
    }

    const targetElement = document.querySelector(targetName)

    if (targetElement) {
      requestAnimationFrame(() => {
        targetElement.scrollIntoView({ behavior: 'auto', block: 'start' })
      })
    }
  }

  const handleBlogBackBtn = () => {
    if (blogParent.length > 1 && getCommentsStatus === PENDING) {
      dispatch(getNotificationMessage({
        type: REJECTED,
        message: 'Please finish loading first before returning to previous blog post or comment',
        isEditProfile: true
      }))
    } else {
      const parentData = blogParent[blogParent.length - 1]

      goToHeaderOriginalPos()

      dispatch(setComments([]))
      if (parentData?.parent_type) {
        document.querySelector('#hiddenItem').scrollIntoView({ behavior: 'instant', block: 'start' })
        dispatch(getComments({
          type: parentData.parent_type,
          ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
        }))
      }
    }

    dispatch(setBlogParent(blogParent.slice(0, -1)))
  }

  const blogModalTitle = () => {
    if (postsOption.type === 'marker' && profileItem) {
      return profileItem?.full_name + "'s Blog"
    }

    if (getPostsStatus === PENDING && posts.length === 0) {
      return ''
    }

    if (chosenNotifBlog?.title) {
      return chosenNotifBlog?.title
    }

    return posts[0]?.full_name ? posts[0]?.full_name + "'s Blog" : ''
  }

  const GoToMarker = (item, notifDrawerWiden) => {
    dispatch(setHideDrawerAnimation(notifDrawerWiden))
    setTimeout(() => dispatch(setHideDrawerAnimation(false)), 1000)

    const backBtn = document.querySelector('#back-button')
    if (backBtn) {
      document.querySelector('#back-button').click()
    }

    closeDrawer()
    dispatch(setCloseChatModal(true))
    setTimeout(() => dispatch(setCloseChatModal(false)), 300)
    document.querySelector('#blog-modal-overlay').click()

    setTimeout(() => {
      let coord = {
        coord: item?.coordinates,
        isStatic: true
      }
      dispatch(showCurrentChatFriendMarkerCoordinate(coord))

      sessionStorage.setItem('openProfileAfterAnimation', item?.profile_id)
    }, 850)
  }

  const chevronDirection = (type) => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      if (type === 'icon') {
        return blogParent.length ? 'rotate(180deg)' : 'rotate(270deg)'
      }

      if (type === 'text') {
        return blogParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
      }
    }

    if (isNotMobile() && type === 'icon') {
      return blogParent.length ? 'rotate(180deg)' : 'rotate(-90deg)'
    }

    if (isNotMobile() && type === 'text') {
      return blogParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
    }

    return 'rotate(180deg)'
  }

  const transition = {
    type: 'tween',
    duration: 0.8
  }

  const transitionWiden = {
    duration: 0.8,
    ease: [0.68, -0.25, 0.265, 1.25]
  }

  const animateVariants = {
    WideScreen: {
      initial: {
        width: '368px',
        height: animateOut ? getDrawerHeight() : '0px',
        y: 0,
        paddingBottom: '20px',
        ...(postsOption.type === 'marker' ? { bottom: '24px' } : {})
      },
      animate: {
        width: shouldWiden() && widenAnimation ? Math.round(window.innerWidth * 0.7) : '368px',
        height: animateOut ? '0px' : getDrawerHeight(),
        y: 0,
        paddingBottom: '0px',
        transition: widenBtnClicked ? transitionWiden : transition
      }
    },
    NarrowScreen: {
      initial: {
        width: '95%',
        height: 'auto',
        marginRight: '10px',
        x: 450
      },
      animate: {
        transition,
        x: 0,
        ...(animateOut ? { marginRight: '-450px' } : {})
      }
    },
    NarrowScreenMarker: {
      initial: {
        width: document.querySelector('#marker-popup-container')?.offsetWidth + 3 + 'px' ?? '366px',
        height: animateOut ? getDrawerHeight() : '0px',
        y: 0,
        bottom: '29px'
      },
      animate: {
        height: animateOut ? '0px' : getDrawerHeight(),
        transition
      }
    }
  }

  const handleAnimationVariants = () => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      return animateVariants.NarrowScreenMarker
    }

    return animateVariants[isNotMobile() ? 'WideScreen' : 'NarrowScreen']
  }

  useEffect(() => {
    setHoveringChevron(false)
  }, [])

  return (
    <StyledDrawerContent
      variants={handleAnimationVariants()}
      initial="initial"
      animate="animate"
      {...(isNotMobile() ? {} : { maxWidth: '450px' })}
      gap="1em"
      transformOrigin={isNotMobile() ? 'right' : 'bottom'}
      onAnimationComplete={() => setWidenBtnClicked(false)}
      onClick={() => {
        if (!isLoggedIn && !askToSignUp) {
          setAskToSignUp(true)
        }
      }}
    >
      <AskToSignUpModal
        dynamicOpenModal={askToSignUp}
        posts={posts}
      />

      <Stack
        alignItems="center"
        justifyContent="space-between"
        direction="row"
        p="0px 5px"
        background={COLORS.goldGradientRightToLeft}
        minHeight="48px"
        borderRadius="10px 10px 0 0"
        marginTop="-1px"
        position="sticky"
        top="-0.2"
        zIndex={1000}
        onClick={() => {
          if (!isLoggedIn && !askToSignUp) {
            setAskToSignUp(true)
          }
        }}
        cursor={isLoggedIn ? 'auto' : 'pointer'}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWidenAnimation(true)
            setWidenBtnClicked(true)
            setWiden(!widen)

            if (isNotMobile()) {
              dispatch(setHideNotification(!widen))
              dispatch(setHideChat(!widen))
            }

            if (
              postsOption.type !== 'marker'
              && isNotMobile()
            ) {
              animateMarkerFilter(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ResizeIcon />}
          id="resize-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'none' : 'flex'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWidenBtnClicked(true)
            setWiden(!widen)

            const notifDrawer = document.querySelector('#notification-drawer-header')
            const chatDrawer = document.querySelector('#chakra-modal--header-chat-list-drawer')
            const onNarrowScreen = (
              (notifDrawer && notifDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
              || (chatDrawer && chatDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
            )

            if (
              onNarrowScreen
              && isNotMobile()
            ) {
              dispatch(setHideNotification(!widen))
              dispatch(setHideChat(!widen))
            }

            if (
              onNarrowScreen
              && postsOption.type !== 'marker'
            ) {
              animateMarkerFilter(true)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ShrinkIcon />}
          id="shrink-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'auto' : 'none'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />

        <Text
          maxWidth="70%"
          fontSize="24px"
          textAlign="center"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          { blogModalTitle() }
        </Text>

        <IconButton
          onClick={() => {
            if (isLoggedIn && !askToSignUp) {
              if (blogParent.length) {
                handleBlogBackBtn()
              } else {
                if (
                  hideNotification
                  && postsOption.type !== 'single'
                  && postsOption.type !== 'marker'
                ) {
                  animateMarkerFilter(true)
                }

                closeDrawer()
              }
            }

            setHoveringChevron(false)
          }}
          onPointerEnter={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(true)
            }
          }}
          onPointerLeave={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          transform={chevronDirection('icon')}
          transition="none"
          icon={(
            <>
              <Text
                fontWeight="300"
                transform={chevronDirection('text')}
                display={hoveringChevron ? 'flex' : 'none'}
              >
                {blogParent.length ? 'Back' : 'Exit'}
              </Text>

              <Stack display={hoveringChevron ? 'none' : 'flex'}>
                <ArrowIcon height="15px" />
              </Stack>
            </>
          )}
          id="blog-modal-back-button"
          outline="none"
          boxShadow="none"
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
      </Stack>

      <Stack
        id="force-close-blog-drawer"
        display="none"
        onClick={() => closeDrawer()}
      />

      <Stack
        position="relative"
        onClick={() => {
          if (!isLoggedIn && !askToSignUp) {
            setAskToSignUp(true)
          }
        }}
      >
        {
          isLoggedIn
          && !askToSignUp
            ? ''
            : (
              <Box
                position="absolute"
                top="0"
                left="0"
                width="100%"
                height="100%"
                zIndex="999"
                cursor={askToSignUp ? '' : 'pointer'}
              />
            )
        }

        <BlogList
          from={from}
          activeProfile={activeProfile}
          blogParent={blogParent}
          chosenBlogIndex={chosenBlogIndex}
          getPostsStatus={getPostsStatus}
          posts={posts}
          postsOption={postsOption}
          profileItem={profileItem}
          chosenNotifBlog={chosenNotifBlog}
          subscribeToProfileStatus={subscribeToProfileStatus}
          adminNotifications={adminNotifications}
          widen={widen}
          setWiden={setWiden}
          GoToMarker={GoToMarker}
          newPostsOption={newPostsOption}
          CommentSection={(
            <Comments
              from={from}
              activeProfile={activeProfile}
              blogParent={blogParent}
              chosenBlogIndex={chosenBlogIndex}
              comments={comments}
              commentsOption={commentsOption}
              getCommentsStatus={getCommentsStatus}
              postCommentsStatus={postCommentsStatus}
              putCommentsStatus={putCommentsStatus}
              widen={widen}
              GoToMarker={GoToMarker}
            />
          )}
        />
      </Stack>
    </StyledDrawerContent>
  )
}
